import axios from 'axios';
import { toast } from 'react-toastify';
import { useMutation, useQueryClient } from 'react-query';

const useSaveChangesIdCard = ({ onModalClose }) => {
  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation(
    async ({ idCardEditedData, idCardImages }) => {
      const validIdCardImages = idCardImages.filter((image) => !!image.imageId);
      idCardEditedData.images = validIdCardImages;
      return await axios.patch(`/idcards/project/${idCardEditedData.id}`, idCardEditedData);
    },
    {
      onSuccess: (res, { idCardEditedData }) => {
        queryClient.invalidateQueries('projectIdCards', { exact: true });
        queryClient.invalidateQueries(['projectIdCards', { tagId: idCardEditedData.projectId }], { exact: true });
        toast.success('Changes Saved', {
          position: toast.POSITION.TOP_LEFT,
        });
        onModalClose();
      },
    }
  );

  return {
    saveChanges: mutate,
    isLoading,
  };
};

export default useSaveChangesIdCard;
